/**
 * Role definitions and related constants
 */

import { UserRole } from "../models/UserRole";

// Interface for role option displayed in UI
export interface RoleOption {
  value: string;
  label: string;
  role: UserRole;
}

// User roles available for assignment
export const ROLE_OPTIONS: RoleOption[] = [
  { value: UserRole.CSM, label: "CSM", role: UserRole.CSM },
  { value: UserRole.TAM, label: "TAM", role: UserRole.TAM },
  // Admin isn't included here if it's not selectable in the UI
];

// Map roles to their display names
export const ROLE_DISPLAY_NAMES: Record<UserRole, string> = {
  [UserRole.Admin]: "Administrateur",
  [UserRole.CSM]: "Customer Success Manager",
  [UserRole.TAM]: "Talent Acquisition Manager",
};

// Role-specific permissions
export const ROLE_PERMISSIONS: Record<UserRole, Record<string, boolean>> = {
  [UserRole.Admin]: {
    canManageUsers: true,
    canManageRoles: true,
    canManageSystem: true,
  },
  [UserRole.CSM]: {
    canManageProjects: true,
    canManageClients: true,
    canViewReports: true,
  },
  [UserRole.TAM]: {
    canManageFreelancers: true,
    canAssignFreelancers: true,
    canViewReports: true,
  },
};

/**
 * Helper functions for roles
 */

/**
 * Get display name for a role
 */
export const getRoleDisplayName = (role: UserRole): string => {
  return ROLE_DISPLAY_NAMES[role] || role;
};

/**
 * Check if a user has a specific permission
 */
export const hasPermission = (role: UserRole, permission: string): boolean => {
  return ROLE_PERMISSIONS[role]?.[permission] || false;
};